module.exports = __webpack_public_path__ + "img/Bravia_BZ35L_Finer detail.9cb0e004.jpg";